import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    notifications: {
      data: [],
      status: statuses.EMPTY,
    },
    notificationsNew: {
      data: [],
      status: statuses.EMPTY,
    },
    notificationsReadUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    typeTranslations: {
      approveRequests: 'Jauns pieprasījums apstiprināšnai',
      declineRequests: 'Pieprasījums noraidīts',
      approvedRequest: 'Pieprasījums apstiprināts',

      invoiceWaitingForAccountantApprove: 'Jauns rēķins apstiprināšnai',
      invoicePaymentAccountantDeclined: 'Rēķins noraidīts no grāmatvedības',
      invoicePaymentDirector1Approved: 'Rēķins apstiprināts no direktors 1',
      invoicePaymentDirector2Approved: 'Rēķins apstiprināts no direktors 2',
      invoicePaymentDirector1Declined: 'Rēķins noraidīts no direktors 1',
      invoicePaymentDirector2Declined: 'Rēķins noraidīts no direktors 2',
      invoiceReviewProcurementApproved: 'Rēķins apstiprināts no iepirkuma speciālista',
      invoiceReviewProcurementDeclined: 'Rēķins noraidīts no iepirkuma speciālista',
      invoiceReviewWaitProcurementApprove: 'Rēķins nosūtīts iepirkuma speciālistam',

      advanceInvoiceWaitingForAccountantApprove: 'Jauns avansa rēķins apstiprināšanai',
      advanceInvoiceReviewWaitProcurementApprove: 'Jauns avansa rēķins izskatīšanai',
      advanceInvoiceReviewProcurementApproved: 'Avansa rēķins apstiprināts no iepirkuma speciālista',
      advanceInvoiceReviewProcurementDeclined: 'Avansa rēķins noraidīts no iepirkuma speciālista',
      advanceInvoicePaymentAccountantDeclined: 'Avansa rēķins noraidīts no grāmatvedības',
      advanceInvoicePaymentDirector1Approved: 'Avansa rēķins apstiprināts no direktors 1',
      advanceInvoicePaymentDirector2Approved: 'Avansa rēķins apstiprināts no direktors 2',
      advanceInvoicePaymentDirector1Declined: 'Avansa rēķins noraidīts no direktors 1',
      advanceInvoicePaymentDirector2Declined: 'Avansa rēķins noraidīts no direktors 2',

    },
    routeMap: {
      WelcomeNotification: 'AuditLogs',
      OrderApprovementNotification: 'OrderUpdate',
      InvoiceApprovementNotification: 'InvoiceUpdate',
      AdvanceInvoiceApprovementNotification: 'AdvanceInvoiceUpdate',
    },
  };
};

const Notifications = {
  namespaced: true,
  state: defaultState,
  getters: {
    notifications: (state) => state.notifications,
    notificationsNew: (state) => state.notificationsNew,
    notificationsReadUpdate: (state) => state.notificationsReadUpdate,
    typeTranslations: (state) => state.typeTranslations,
    routeMap: (state) => state.routeMap,
  },
  mutations,
  actions,
};

export { Notifications, defaultState };
